import React, {useState} from 'react';

const Client = (props) => {
    const vmin = Math.min(window.innerWidth, window.innerHeight);
    if(Object.keys(props.clientPosition).length === 0){
        return null;
    }
    const textStyle = {
        color: props.clientPosition.textColor,
        fontFamily: props.clientPosition.fontFamily,
        fontWeight: props.clientPosition.fontWeight,
        fontStyle: props.clientPosition.fontStyle,
        fontSize: `${(props.clientPosition.fontSize || 2) * (props.viewHeight || vmin) / 100}px`
    }
    const contactNameStyle = {
        top: props.clientPosition.position_name_y+"%",
        left: props.clientPosition.position_name_x+"%",
        display: (props.clientPosition.show_name !== false) ? "block" : "none",
        zIndex: 1,
        ...textStyle,
    }
    const contactPhoneStyle = {
        top: props.clientPosition.position_phone_y+"%",
        left: props.clientPosition.position_phone_x+"%",
        display: (props.clientPosition.show_phone !== false) ? "block" : "none",
        zIndex: 1,
        ...textStyle,
    }
    const contactEmailStyle = {
        top: props.clientPosition.position_contact_y+"%",
        left: props.clientPosition.position_contact_x+"%",
        display: (props.clientPosition.show_contact !== false) ? "block" : "none",
        zIndex: 1,
        ...textStyle,
    }
    const clientLogoStyle = {
        width: props.clientPosition.width+"%",
        top: props.clientPosition.position_logo_y+"%",
        left: props.clientPosition.position_logo_x+"%",
        display: (props.clientPosition.show_logo !== false) ? "block" : "none",
    }

    return(
        <div className="client_wrap">
            <div className="logo-wrapper">
                {/*<p className="client_name" style={clientNameStyle}>{props.clientData.client_name}</p>*/}
                <p className="contact_name" style={contactNameStyle}>{props.clientData.contact_name}</p>
                <p className="contact_phone" style={contactPhoneStyle}>{props.clientData.contact_phone}</p>
                <p className="contact_email" style={contactEmailStyle}>
                    {props.clientPosition.emailButton ? (<i class="fa fa-envelope"></i>) : props.clientData.contact_email}
                </p>
                <img className="client-logo" src={props.clientPosition.logo.replace('/media', 'https://storage.googleapis.com/ifloorplan-8278e.appspot.com')} style={clientLogoStyle}/>
            </div>
        </div>
    )
}
export default Client;